import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import download from '../images/download-doc.svg';
import { Button, IconButton } from '@mui/material';
import EnhancedTableHead from './EnhancedTableHead.index';
import { withTranslation } from 'react-i18next';
import SearchableMultiSelect from "../../common/SearchableMultiSelect";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import TextField from '@mui/material/TextField';
import moment from 'moment-timezone';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from '../../../utils/datetime.utils';
import GraphView from './graph-view';
import Loader from './Loader';
import {
  StyledDivider,
  StyledTable,
  StyledTableWrapper,
  StyledTCellBody,
  StyledTextField,
  StyledTRowBody,
  styles,
} from './styledComponents';
import { convertToTimeZone } from '../../../utils/datetime.utils';
import {
  getSorting,
  gettingOnSortTableName,
  stableSort,
} from './helpers/data.helpers';
import BoxReportTRow from './table-view/BoxReportTRow';

const localeTheme = createTheme(
  {},
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR
);

let BoxUtitlizationFilterObj = {
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  searchtext: '',
  tableName: '',
  store_ids: null,
  fromdate: '',
  todate: '',
};

class KioskBoxUtilization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      page: 0,
      rowsPerPage: 10,
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      searchText: '',
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      loader: false,
      isDataEmpty: true,
      data: [],
      totalRecords: 0,
      isButtonDisabled: false,
      toggleGraph: false,
      selectedYear: new Date().getFullYear() - 1,
      queryId: "",
      groups: [],
      chipstores: [],
      accountValues: [],
      nstores: [],
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.debouceTimeout = null;
  }

  componentDidMount() {
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    BoxUtitlizationFilterObj = {
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'created_on',
      searchtext: '',
      tableName: '',
      store_ids: [],
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate)
    }
    this.BindBoxUtilization();
    this.fetchAccounts();
  }

  onSearchChange(event) {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchText: searchString && searchString });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.sortOrder = 'desc';
    BoxUtitlizationFilterObj.sortColumn = 'created_on';
    BoxUtitlizationFilterObj.tableName = '';
    BoxUtitlizationFilterObj.store_ids = [];
    BoxUtitlizationFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindBoxUtilization();
    }, 1000);
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/KioskUtilizationReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRow = [];
        let Elements = [
          [
            'Id',
            'Store',
            'Box',
            'Total Bins',
            'Available Bins',
            'Pharmacy Occupied Bins',
            'Optical Occupied Bins',
            'Occupied Bins',
            'Pharmacy Utilization',
            'Optical Utilization',
            'Utilization',
            'Date',
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              Elements.push([
                i.store,
                i.box,
                i.total_bins,
                i.available_bins,
                i.pharmacy_used_bins,
                i.optical_used_bins,
                i.use_bins,
                i.pharmacy_utilization ? i.pharmacy_utilization + '%' : '',
                i.optical_utilization ? i.optical_utilization + '%' : '',
                i.box_utilization ? i.box_utilization + '%' : '',
                convertToTimeZone(i.utilization_date) || '',
              ]);
            }

            for (let i of Elements) {
              csvRow.push(i.join(','));
            }
            let csvString = csvRow.join('%0A');
            let element = document.createElement('a');
            element.href = 'data:attachment/csv.' + csvString;
            element.target = '_Blank';
            element.download = 'KioskUtilizationReport.csv';
            document.body.appendChild(element);
            element.click();
          }
        }
      });
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    BoxUtitlizationFilterObj.sortOrder = order;
    BoxUtitlizationFilterObj.sortColumn = field;
    BoxUtitlizationFilterObj.tableName = gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    BoxUtitlizationFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindBoxUtilization();
    }
  };

  BindBoxUtilization() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + 'kioskBoxUtilization', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(BoxUtitlizationFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        this.setState({ totalRecords: uData && uData.total });
        if (uData && uData.results && uData.results.length > 0) {
          this.setState({
            data: uData && uData.results,
            loader: uData && uData.total && false,
            isDataEmpty: false,
            isButtonDisabled: false,
          });
        } else {
          this.setState({
            data: null,
            loader: false,
            isDataEmpty: true,
            isButtonDisabled: true,
          });
        }
      });
  }


  fetchAccounts = async () => {
    await fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const { t } = this.props
        let All = [{ id: "-1", name: t("Global.Label.DropDown.All") }]
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });
        const accountValues = All.concat(storelist);
        this.setState({ accountValues, parent_account_id: accountValues[0].id });
      });
  }

  handleStoreChange = event => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');

    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    }
    else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({ store_id: storeids });
    BoxUtitlizationFilterObj.store_ids = storeids;
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.sortOrder = 'desc';
    BoxUtitlizationFilterObj.sortColumn = 'created_on';
    BoxUtitlizationFilterObj.tableName = '';

    this.BindBoxUtilization();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      BoxUtitlizationFilterObj.store_ids = [];
      BoxUtitlizationFilterObj.pageNo = 0;
      this.BindBoxUtilization();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.setState({ store_id: storeids });
    BoxUtitlizationFilterObj.store_ids = storeids;
    BoxUtitlizationFilterObj.pageNo = 0;
    this.BindBoxUtilization();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    BoxUtitlizationFilterObj.store_ids = [];
    BoxUtitlizationFilterObj.pageNo = 0;
    this.BindBoxUtilization();
  };
  
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindBoxUtilization();
  };

  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindBoxUtilization();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindBoxUtilization();
  }
  
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindBoxUtilization();
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    BoxUtitlizationFilterObj.pageNo = 0;
    BoxUtitlizationFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    BoxUtitlizationFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindBoxUtilization();
  };

  render() {
    const { t } = this.props;
    const {
      data,
      totalRecords,
      searchText,
      isButtonDisabled,
      toggleGraph,
      fromdate,
      todate,
      dateRangePreset,
      locale,
    } = this.state;

    return (
      <Paper>
        {this.state.loader ? <Loader /> : null}
        <div>
          {toggleGraph ? (
            <React.Fragment>
              <div
                style={{
                  margin: '10px',
                  display: 'flex',
                  alighItem: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Button
                  style={{
                    width: '15%',
                    borderBottom: 'none',
                  }}
                  onClick={() => {
                    this.setState({ toggleGraph: false });
                  }}
                >
                  Table View
                </Button>
              </div>
              <GraphView
                setLoader={(val) => {
                  this.setState({ loader: val });
                }}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div>
                <StyledTable>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          width: '15%',
                          borderBottom: 'none',
                        }}
                      >
                        <Button
                          onClick={() => {
                            this.setState({ toggleGraph: true });
                          }}
                        >
                          Graph View
                        </Button>
                      </TableCell>
                      <TableCell style={{ width: '12%', borderBottom: 'none' }}>
                        <FormControl sx={{ width: '100%' }}>
                          <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                          <Select
                            value={dateRangePreset}
                            onChange={this.handleDateRangePresetChange}
                            variant="standard"
                            label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                          >
                            <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                            <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                            <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                            <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell style={{ width: '12%', borderBottom: 'none' }}>
                        <FormControl sx={{ width: '100%' }}>
                          <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                            <DesktopDatePicker
                              disableFuture
                              keyboard
                              value={fromdate}
                              renderInput={(params) =>
                                <TextField
                                  {...params}
                                  label={t("Report.Transaction.FromDate")}
                                  variant="standard"
                                  allowKeyboardControl={true}
                                  onBlur={this.handleBlurfrom}
                                />
                              }
                              onChange={this.onFromDateSelect}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </TableCell>
                      <TableCell style={{ width: '12%', borderBottom: 'none' }}>
                        <FormControl sx={{ width: '100%' }}>
                          <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                            <DesktopDatePicker
                              disableFuture
                              keyboard
                              value={todate}
                              renderInput={(params) =>
                                <TextField
                                  {...params}
                                  label={t("Report.Transaction.ToDate")}
                                  variant="standard"
                                  allowKeyboardControl={true}
                                  onBlur={this.handleBlurtodate}
                                />
                              }
                              onChange={this.onToDateSelect}
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <StyledTextField
                          id="idsearchtxt"
                          defaultValue=""
                          value={searchText}
                          label={t('Report.KioskUtil.Search')}
                          onChange={this.onSearchChange}
                          fullWidth
                          inputProps={{
                            autocomplete: 'new-search',
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                          variant="standard"
                        />
                      </TableCell>
                      <TableCell style={{ borderBottom: 'none' }}>
                        <SearchableMultiSelect
                          label={t("Report.Assign.Store")}
                          items={this.state.accountValues || []}
                          selectedChips={this.state.chipstores}
                          selectedItems={this.state.nstores}
                          onChange={this.handleStoreChange}
                          onDeleteChip={this.handleDeleteStoreChip}
                          onClearAll={this.handleClearAllStores}
                          placeholder="Search stores..."
                          id="select-multiple-chip-store"
                        />
                      </TableCell>
                      <TableCell
                        style={{
                          width: '25%',
                          borderBottom: 'none',
                          textAlign: 'right',
                        }}
                      >
                        <Tooltip
                          title={t('Report.KioskUtil.ExportCSVTooltip')}
                          style={{ marginRight: '0' }}
                          aria-label="ExportCSV"
                        >
                          <IconButton disabled={isButtonDisabled}>
                            <img
                              alt="download"
                              src={download}
                              onClick={() => this.exportCSV()}
                              style={{
                                height: '32px',
                                width: '32px',
                                cursor: 'pointer',
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </StyledTable>
              </div>
              <StyledDivider />
              <StyledTableWrapper>
                <StyledTable>
                  <EnhancedTableHead
                    order={BoxUtitlizationFilterObj.sortOrder}
                    orderBy={BoxUtitlizationFilterObj.sortColumn}
                    sortId={this.state.sortId}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {!data ? (
                      <StyledTRowBody>
                        <StyledTCellBody
                          colSpan={8}
                          sx={{ textAlign: 'center' }}
                        >
                          {this.state.isDataEmpty &&
                            t('Report.KioskUtil.NoDataFoundText')}
                        </StyledTCellBody>
                      </StyledTRowBody>
                    ) : (
                      data &&
                      data.length > 0 &&
                      stableSort(
                        data,
                        getSorting(
                          BoxUtitlizationFilterObj.sortOrder,
                          BoxUtitlizationFilterObj.sortColumn
                        )
                      ).map((n, i) => <BoxReportTRow rowData={n} key={i} />)
                    )}
                  </TableBody>
                </StyledTable>
              </StyledTableWrapper>
              <ThemeProvider theme={localeTheme}>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalRecords || 0}
                  rowsPerPage={BoxUtitlizationFilterObj.pageSize}
                  page={BoxUtitlizationFilterObj.pageNo}
                  backIconButtonProps={{
                    'aria-label': 'Previous Page',
                  }}
                  nextIconButtonProps={{
                    'aria-label': 'Next Page',
                  }}
                  onPageChange={this.handleChangePage}
                  onRowsPerPageChange={this.handleChangeRowsPerPage}
                />
              </ThemeProvider>
            </React.Fragment>
          )}
        </div>
      </Paper>
    );
  }
}

KioskBoxUtilization.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(KioskBoxUtilization));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/index.js